import { render, staticRenderFns } from "./CreateCaseModal.vue?vue&type=template&id=06a637f6"
import script from "./CreateCaseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCaseModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports